import React, { useState } from "react";
import { Navbar } from "react-bootstrap";
import QuestGridLogo from "../../Images/QuestGridLogo.png";
import TycoonlandLogo from "../../Images/tycoonland.png";
import "../../components/Navbar/Navbar.css";

function NavbarComponent() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    console.log('Hamburger clicked! Current state:', isMenuOpen);
    setIsMenuOpen(!isMenuOpen);
  };

  const handleTycoonlandClick = () => {
    window.open('https://tycoonland.nyc', '_blank');
  };

  return (
    <div className="header-container">
      <Navbar bg="light" expand="lg">
        <div className="navbar-content">
          <div className="hamburger-menu" onClick={toggleMenu}>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
          </div>
          
          {isMenuOpen && (
            <div className="dropdown-menu">
              <div className="menu-item tycoonland-item" onClick={handleTycoonlandClick}>
                <img src={TycoonlandLogo} alt="Tycoonland" className="tycoonland-menu-logo" />
                Tycoonland ®
              </div>
            </div>
          )}
          
          <img className="quest-logo" src={QuestGridLogo} alt="logo" />
        </div>
      </Navbar>
    </div>
  );
}

export default NavbarComponent;